import { TCString } from "@iabtcf/core/lib/TCString";
import { createLogger } from "../../utils";
const logger = createLogger("cmp-utils");
var AlmaB2CCmpEvent;
(function (AlmaB2CCmpEvent) {
    AlmaB2CCmpEvent["AlmaCmpV2Available"] = "alma_cmp_v2_available";
    AlmaB2CCmpEvent["AlmaCmpV2HasOptedin"] = "alma_cmp_v2_has_optedin";
    AlmaB2CCmpEvent["AlmaCmpV2OptinDone"] = "alma_cmp_v2_optin_done";
    AlmaB2CCmpEvent["AlmaCmpV2ConsentAvailable"] = "alma_cmp_v2_consent_available";
    AlmaB2CCmpEvent["AlmaCmpV2ConsentAvailableRepetitive"] = "alma_cmp_v2_consents_available_repetitive";
})(AlmaB2CCmpEvent || (AlmaB2CCmpEvent = {}));
function decodeTCString(consentString) {
    if (!consentString) {
        logger.logInfo(`Consent string is empty`);
        return undefined;
    }
    try {
        const decodedConsent = TCString.decode(consentString);
        // Really spammy because of events being fired that contain this
        // logger.logInfo(
        //   `Decoding consent data object ${JSON.stringify(decodedConsent, null, 2)}`
        // );
        return decodedConsent;
    }
    catch (e) {
        logger.logError(`Unable to decode consent string: ${e}`);
        return undefined;
    }
}
function parseConsentDataString(consentDataString) {
    logger.logInfo(`Trying to parse consent data string as JSON`);
    if (!consentDataString) {
        logger.logInfo(`Consent string is empty`);
        return undefined;
    }
    let consentDataObject;
    try {
        consentDataObject = JSON.parse(consentDataString);
    }
    catch (e) {
        logger.logError(`Unable to parse consent data string: ${e}`);
        return undefined;
    }
    logger.logInfo(`Decoding consent data object ${JSON.stringify(consentDataObject, null, 2)}`);
    try {
        const decodedConsent = decodeTCString(consentDataObject.TCString);
        logger.logInfo(`Decoding consent data object ${JSON.stringify(decodedConsent, null, 2)}`);
        return decodedConsent;
    }
    catch (e) {
        logger.logError(`Unable to decode consent string: ${e}`);
        return undefined;
    }
}
// eslint-disable-next-line import/prefer-default-export
function parseTCCore(tcData) {
    const tcCore = {
        created: tcData.created,
        lastUpdated: tcData.lastUpdated,
    };
    return tcCore;
}
export { AlmaB2CCmpEvent, parseConsentDataString, decodeTCString, parseTCCore };
//# sourceMappingURL=utils.js.map